import { Outlet } from 'react-router-dom';

const ProtectedPaymentRoutes = () => {
    return <Outlet />;
};

export default ProtectedPaymentRoutes;